import React, { useEffect, useState } from 'react';
import "./Kitchens.css";
import axios from 'axios';
import Typography from "@mui/material/Typography";
import jwt_decode from 'jwt-decode';
import {
    Autocomplete,
    Grid,
    TextField,
    Button,
    Box,
    Dialog

} from "@mui/material";

function Kitchens (props) {

    const {
        kitchens
      } = props;
    const token = localStorage.getItem('token');
    const apiAddress = process.env.REACT_APP_SECRET;
    // const [kitchens, setKitchens] = useState([]);
    const [selections, setSelections] = useState({});
    console.log("changed from kitcens: ", kitchens);

    useEffect(() => {
        props.getKitchens(selections)
        console.log(selections) 
    }, [selections]);

    useEffect(() => {
        const initialSelections = kitchens.reduce((acc, kitchen) => {
            kitchen.sections.forEach(section => {
                const defaultValue = kitchen.kitchens.find(k => k.kitchenName === section.kitchen);
                acc[section.id] = defaultValue || null;
            });
            return acc;
        }, {});
        setSelections(initialSelections);
    }, [kitchens]);

    const handleSelectionChange = (sectionId, newValue) => {
        setSelections(prev => ({
            ...prev,
            [sectionId]: newValue
        }));
    };

    return (
        <div>
            {kitchens.map((kitchen, idx) => (
                kitchen.sections.length > 0 && (
                    <div key={kitchen.id}>
                        <div className={`mb-3 ms-5 ${idx > 0 ? "mt-5" : "mt-2"}`}>
                            <Grid item xs={12}>
                                <Typography variant="h5" sx={{ marginLeft: { xs: '0.5rem', sm: '1rem' } }}>
                                    {kitchen.restaurantName}
                                </Typography>
                            </Grid>
                        </div>
                        <div className="kitchen-input">
                            {kitchen.sections.map((section) => (
                                <div key={section.id} className="w-100 pe-4">
                                    <Grid item xs={12} sm={5} sx={{ paddingRight: { xs: '0', sm: '1rem' } }}>
                                        <Typography sx={{ paddingY: '.2rem' }}>
                                            {section.sectionName}
                                        </Typography>
<Autocomplete
    id={`single-select-${section.id}`}
    options={kitchen.kitchens.filter(k => {
        const name = k.kitchenName?.toLowerCase();
        return name !== "manager view" && name !== "waiter view";
    })}
    getOptionLabel={(option) => option.kitchenName}
    value={selections[section.id] || null}
    onChange={(event, newValue) => handleSelectionChange(section.id, newValue)}
    renderInput={(params) => (
        <TextField {...params} label="Select Option" variant="outlined" />
    )}
    sx={{ width: '100%', paddingY: '.5rem' }}
/>



                                    </Grid>
                                </div>
                            ))}
                        </div>
                    </div>
                )))}
        </div>
    );
};


export default Kitchens;